export default __webpack_public_path__ + "static/media/qtyandcs2.72e0e513.jpg";